export default __webpack_public_path__ + "static/media/expand.b1358cae.svg";